import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import InputField from "../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../utils/api";
import { validateNumberInput } from "../../../utils/validateFields";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const GeneralDisclosure229 = ({ hide }) => {
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const questionData = [
    {
      fieldName: "approachengaging",
      title:
        "a. Describe organization's approach to engaging with  its stakeholders.",
      type: "text",
      placeholder: "Enter Text",
      letter: "a.",
    },
    {
      fieldName: "specifyMethodlogyUse",
      title:
        "i. Describe the categories of stakeholders organization engage with and how does the organization identify its key stakeholders. Explain if there's any specific process or methodology used.",
      type: "text",
      placeholder: "Enter Text",
      letter: "i.",
    },
    {
      fieldName: "stakeholderEngagementPurposes",
      title:
        "ii. Describe the organization's main purposes for engaging with stakeholders.",
      type: "text",
      placeholder: "Enter Text",
      letter: "ii.",
    },
    {
      fieldName: "meaningfulStakeholderEngagement",
      title:
        "iii. Describe how the organization seeks to ensure meaningful engagement with stakeholders.",
      type: "text",
      placeholder: "Enter Text",
      letter: "iii.",
    },
  ];

  const { id } = useParams();
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GeneralDisclosures2021`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const res1 =
        res?.data?.data?.GeneralDisclosures2021?.stakeholderEngagementApproach
          ?.stakeholderOrg;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      approachengaging: data?.approachengaging || "",
      specifyMethodlogyUse: data?.specifyMethodlogyUse || "",
      stakeholderEngagementPurposes: data?.stakeholderEngagementPurposes || "",
      meaningfulStakeholderEngagement:
        data?.meaningfulStakeholderEngagement || "",
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "distance" && !validateNumberInput(value)) return;
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    questionData.forEach((el) => {
      if (!formData[el.fieldName] || formData[el.fieldName].trim() === "") {
        newErrors[el.fieldName] = "This field is Required";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;
      let transformedData2 = {
        stakeholderEngagementApproach: { stakeholderOrg: formData },
        type: "GeneralDisclosures2021",
        submitted2_29: true,
      };
      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/general-disclosure/2-30/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-30/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1.2rem" : "1.5rem" }}
      >
        2-29 Approach to stakeholder engagement
      </p>
      {/* a */}
      {questionData.map((el) => (
        <Box sx={{ ml: el.fieldName !== "approachengaging" && 2 }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            {/* <p className={styles.ques_heading}>{el.letter}</p> */}
            <p className={styles.ques_heading} style={{textIndent:"-0.8rem",paddingLeft:"1rem"}}>{el.title}</p>
          </Box>
          <Box sx={{ ml: 2.5 }}>
            <InputField
              placeholder={"Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={handleChange}
              mt="-5px"
              errors={errors[el.fieldName] && true}
              disabled={disabled}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                marginTop: hide ? "-1.2rem" : "0rem",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[el.fieldName]}
            </p>
          </Box>
        </Box>
      ))}
    </>
  );
  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GeneralDisclosure229;
